import { render } from "./ContentPageHeader.vue?vue&type=template&id=6b1e5592&scoped=true"
import script from "./ContentPageHeader.vue?vue&type=script&lang=js"
export * from "./ContentPageHeader.vue?vue&type=script&lang=js"

import "./ContentPageHeader.vue?vue&type=style&index=0&id=6b1e5592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1e5592"]])

export default __exports__